import React, { useState, useEffect, useContext } from 'react';
import { useHistory, withRouter } from "react-router-dom";
import { Typography, Input, Button, Dropdown, Menu, Icon, message, Tabs } from "antd";


const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;
const { TabPane } = Tabs

import SparesTable from './SparesTable';
import WrappedSparesModal from './SparesModal';
import '../index.less';
import { platformApi } from '../../../../api'
// import { set } from 'lodash';
import WrappedSIForm from './SIForm';
import { ContextAPI } from '../../../../ContextAPI';

const SparesInventory = () => {
    const [dataSource, setData] = useState([]);
    const [selected, setSelected] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [open, setOpen] = useState(false);
    const [spinning, setSpinning] = useState(false);
    const [editable, setEditable] = useState(false);

    const [createAccess, setCreateAccess] = useState(false);
    const [modifyAccess, setModifyAccess] = useState(false);
    const [deleteAccess, setDeleteAccess] = useState(false);

    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [limit, setLimit] = useState(10);

    const [total, setTotal] = useState(0);
    const [searches, setSearch] = useState('');
    const [branch, setBranch] = useState([]);
    const [filteropen, setFilteropen] = useState(false);
    const [visible, setVisible] = useState(false)
    const [pendingTransfers, setPendingTransfers] = useState([]);
    const { loginCredintials } = useContext(ContextAPI);
    const history = useHistory();

    const getMenu = () => {
        let size = count / 10 + (count % 10) ? 1 : 0;
        const menus = [];
        menus.push(10);
        size = size <= 10 ? size : 10;
        for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
        return menus.map((menu) => (
            <Item onClick={() => { setLimit(menu), setPage(1) }} key={menu}>
                {menu}
            </Item>
        ));
    };
    const menu = <Menu>{getMenu()}</Menu>;

    useEffect(() => {
        platformApi
            .get("/api/sparesInventory/pendingTransfers")
            .then((res) => {
                if (res?.data?.response?.code === 200) {
                    setPendingTransfers(res.data.response.data.recommendations || []);
                }
            })
            .catch((err) => console.error("Error fetching pending transfers:", err));
    }, []);
    useEffect(() => {
        getPSI(searches);
    }, [page, limit, searches]);
    useEffect(() => {
        loginCredintials.roleAccess &&
            loginCredintials.roleAccess.map((each) => {
                if (each.subModule === "spares_inventory") {
                    if (each.access.create) {
                        setCreateAccess(true);
                    }
                    if (each.access.update) {
                        setModifyAccess(true);
                    }
                    if (each.access.delete) {
                        setDeleteAccess(true);
                    }
                }
            });
        // }
    }, []);

    const collapseFilter = () => {
        filteropen ? setFilteropen(false) : setFilteropen(true);
    };

    const getPSI = (searches, val) => {
        setSpinning(true)
        const branchData = localStorage.getItem('branch');
        const branchIds = branchData ? JSON.parse(branchData).map(branch => branch.id) : [];
        platformApi.post("/api/sparesInventory/get", {
            page: val ? val : page,
            size: limit,
            searchString: searches && searches.name,
            branch: branchIds
        }).then((result) => {
            setSpinning(false)
            let { data } = result;
            if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                    setCount(response.data.count);
                    setTotal(response.data.total)
                    let groupedData = {};
                    response.data.sparesInventory.forEach((item) => {
                        const partId = item?.partNo?.id;
                        if (!partId) return;

                        if (!groupedData[partId]) {
                            groupedData[partId] = {
                                ...item,
                                branch: []
                            };
                        }

                        groupedData[partId].branch.push({
                            partId: item.partNo.id,
                            sparesId: item.id,
                            branch: item.branch,
                            binNum: item.binNum,
                            reorderQuantity: item.reorderQuantity,
                            maxStock: item.maxStock,
                            minStock: item.minStock,
                            reorderLevel: item.reorderLevel,
                            phyQuantity: item.phyQuantity,
                            accQuantity: item.accQuantity,
                            transactions: item.transactions,
                            allocatedQuantity: item.allocatedQuantity
                        });

                        if (item.transactions) {
                            if (!groupedData[partId].transactions) {
                                groupedData[partId].transactions = {
                                    sparesPurchase: [],
                                    sparesSale: []
                                };
                            }
                            groupedData[partId].transactions.sparesPurchase = [
                                ...groupedData[partId].transactions.sparesPurchase,
                                ...(item.transactions.sparesPurchase || [])
                            ];
                            groupedData[partId].transactions.sparesSale = [
                                ...groupedData[partId].transactions.sparesSale,
                                ...(item.transactions.sparesSale || [])
                            ];
                        }
                    });

                    let finalData = Object.values(groupedData);
                    setData(finalData);
                    //setData(val);
                } else {
                    message.error(response?.msg || 'Unable to fetch spares inventory', 2);
                }
            } else {
                message.error(data?.msg || 'Unable to fetch spares inventory', 2);
            }
        })
            .catch((err) => {
                setSpinning(false)
                console.error("PSI Fetch Error: ", err);
                message.error("Couldn't Fetch PSI");
            });
    }
    return (
        <div>
            <div className="accessories-head">
                <div className="add-inventory">
                    <Title className="heading" style={{ width: "60%" }} level={4}>
                        Spares Inventory [{count}]
                    </Title>
                    <Button
                        type="primary"
                        onClick={() => {
                            setVisible(true)
                        }}
                        // style={{ margin: "0 3%", width: "20%" }}
                        // type="primary"
                        disabled={!createAccess}
                    >
                        Add to Inventory
                    </Button>
                    {pendingTransfers.length > 0 && (
                        <Button
                            type="danger"
                            style={{
                                backgroundColor: "#ff4d4f",
                                borderColor: "#ff4d4f",
                                color: "#fff",
                                fontWeight: 600,
                                marginLeft: 12,
                                borderRadius: 4,
                                boxShadow: "0 2px 4px rgba(255,77,79,0.3)"
                            }}
                            onClick={() => {
                                history.push("/autoadmin/transfer/spares");
                            }}
                        >
                            ⚡ Auto Transfer Spares ({pendingTransfers.length} Action Needed)
                        </Button>
                    )}
                </div>
                {loginCredintials?.role === 'CEO' && (
                    <div className="add-inventory">
                        <Title level={4}>
                            Total Cost:&nbsp;{total}
                        </Title>
                    </div>
                )}
                <div className="search-inventory">
                    <Search
                        style={{ width: "80%" }}
                        placeholder="Search Inventory"
                        onSearch={(event) => {
                            let searches = { name: event };
                            setPage(1)
                            setSearch(searches);
                        }}
                        onChange={(event) => {
                            if (event.target.value === "") {
                                setSearch(null)
                                setPage(1)
                            }
                        }}
                    // onSearch={(event) => {
                    //     let searches = { name: event };
                    //     setPage(1);
                    //     setSearch(searches);
                    // }}
                    // onChange={(event) => {
                    //     if (event.target.value === "") {
                    //     setSearch(null);
                    //     setPage(1);
                    //     }
                    // }}
                    />
                    {/* <div style={{ width: "12%", textAlign: "center" }}>
                        <Button
                            type="link"
                            onClick={() => {
                                collapseFilter();
                            }}
                        >
                            {filteropen ? "Back" : "Advanced  Filters"}
                        </Button>
                    </div> */}
                </div>
            </div>
            <SparesTable
                pagination={{
                    onChange: (page) => {
                        setPage(page);
                    },
                    pageSize: limit,
                    defaultCurrent: 1,
                    current: page,
                    total: count,
                    showQuickJumper: true,
                }}
                openModal={(data) => {
                    setSelected(data)
                    setSelectedData(data)
                    setOpen(true);
                }}
                dataSource={dataSource}
                spinner={spinning}
                getPSI={getPSI}
            // delete={deleteData}
            // deleteAccess={deleteAccess}
            // modify={modifyAccess}
            />

            <WrappedSIForm
                visible={visible}
                setVisible={setVisible}
                getPSI={getPSI}
                close={() => {
                    setVisible(false)
                }}
            />

            <WrappedSparesModal
                data={selectedData}
                open={open}
                editable={editable}
                close={() => {
                    setOpen(false);
                    setSelected(false);
                    setSelectedData(null)
                }}
                getPSI={getPSI}
                modify={modifyAccess}
            />
        </div>
    )
}

export default withRouter(SparesInventory);